<template>
  <div id="verificacion">
    

    <section v-if="loaded">
      <div class="container azul mt-5">
        <div class="row pt-5">
          <div class="col-12 pb-5">
            <p class="fG text-center">
              ¡Hola
              <span class=" bold">{{ nombre }}</span>!
            </p>
            <p class="fG text-center azul">
              Has verificado tu cuenta, ya puedes ingresar
              <router-link to="/" class="azul underlined">aquí</router-link> para
              participar.
            </p>

            <!-- <p class="fG text-center">
              Te hemos enviado un cupón de cortesía por correo o bien descárgalo
              a continuación:
            </p>

            <p class="text-center">
              <img :src="link_imagen" alt="cupon" />
            </p>

            <a
              download="cupon-inseparables.jpg"
              :href="link_imagen"
              class="amarillo btn-amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Descargar cupón
            </a> -->
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";
import Swal from "sweetalert2";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      monto: null,
      no_sucursal: null,
      id: this.$route.params.id,
      codigo: this.$route.params.codigo,
      link_imagen: null,
      nombre: "",
      loaded: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.verifica();
  },
  methods: {
    verifica() {
      this.$store.dispatch("showLoader", true);

      const https = require("https");
      var qData = {
        id: this.id,
        codigo: this.codigo,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "verificacion2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            // console.log("verificacion mail");
            //console.log(response);
            this.$store.dispatch("showLoader", false);

            let res = response.body;
            //let res = JSON.parse(response);

            if (res.status == "ok") {
              this.link_imagen = res.link_imagen;
              this.nombre = res.nombre;
              this.loaded = true;
            } else {
              Swal.fire(
                "Oops",
                "Hubo un error al verificar estos datos, por favor recarga esta página o da clic nuevamente en el link del correo enviado."
              );
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            this.$store.dispatch("showLoader", false);
            Swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo."
            );
          }
        );
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.underlined{
  text-decoration: underline;
}
</style>
